import { ReceiptText } from 'lucide-react';
import { List } from "lucide-react";
import { FilePlus } from "lucide-react";
import { Thermometer } from "lucide-react";
import { Euro } from "lucide-react";
import { Settings } from "lucide-react";
import { Navbar } from "../../../components/navbar/navbar";
import React, { useEffect, useState } from "react";

import "./Bureau_etudes.scss";
import { Tabs } from "@mantine/core";
import { Catalogue_blu } from "./Catalogue_blu/Catalogue_blu";
import { Outils_admin } from "./Outils_admin/Outils_admin";
import { useDispatch } from "react-redux";
import { setMobile_sidebar_icon } from "../../../store/interfaceSlice";
import { Logs_viewer_bureau_etude } from "./logs_viewer_bureau_etude";
import { Statut_cellule_admin } from "./Statut_cellule_admin/Statut_cellule_admin";
import { Sondes } from "./Statut_cellule_admin/Sondes";

export function Bureau_etudes() {
  const dispatch = useDispatch();
  dispatch(setMobile_sidebar_icon("aucun"));

  const [activeTab, setActiveTab] = useState<string | null>("be_admin");

  return (
    <div className={"app"}>
      <Navbar />
      <div className={"content content-fullwidth page_be"}>
        <Tabs className={"Tabs"} value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="be_admin" leftSection={<Settings />}>
              Outils d'administration
            </Tabs.Tab>
            <Tabs.Tab value="catalogue" leftSection={<FilePlus />}>
              Catalogue Blulog
            </Tabs.Tab>
            <Tabs.Tab value="logs" leftSection={<List />}>
              Logs
            </Tabs.Tab>
            <Tabs.Tab value="statuts" leftSection={<ReceiptText />}>
              Paiements
            </Tabs.Tab>
            <Tabs.Tab value="sondes" leftSection={<Thermometer />}>
              Sondes
            </Tabs.Tab>
            {/*<Tabs.Tab value="page5" icon={<Icone nom={"gear"} />}>Page 5</Tabs.Tab>*/}
          </Tabs.List>

          <Tabs.Panel value="be_admin" pt="xs">
            <Outils_admin />
          </Tabs.Panel>

          <Tabs.Panel value="catalogue" pt="xs">
            {activeTab === "catalogue" && <Catalogue_blu />}
          </Tabs.Panel>

          <Tabs.Panel value="logs" pt="xs">
            {activeTab === "logs" && <Logs_viewer_bureau_etude />}
          </Tabs.Panel>

          <Tabs.Panel value="statuts" pt="xs">
            {activeTab === "statuts" && <Statut_cellule_admin />}
          </Tabs.Panel>

          <Tabs.Panel value="sondes" pt="xs">
            {activeTab === "sondes" && <Sondes />}
          </Tabs.Panel>
        </Tabs>
      </div>
    </div>
  );
}
